export default __webpack_public_path__ + "static/media/SJA1590.34I-43626_-26043_0.06283bc5.jpg";